<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xl-7">
        <img
            class="bg-img-cover bg-center"
            src="../../assets/images/login/2.jpg"
            alt="looginpage"
        />
      </div>
      <div class="col-xl-5 p-0">
        <div class="login-card">
          <div>
            <div>
              <a class="logo text-left">
                <img
                    class="img-fluid for-light"
                    src="../../assets/images/logo/login.png"
                    alt="looginpage"
                />
                <img
                    class="img-fluid for-dark"
                    src="../../assets/images/logo/logo_dark.png"
                    alt="looginpage"
                />
              </a>
            </div>
            <div class="login-main login-form-card">
              <form class="theme-form" @submit.prevent="signUp">
                <h4>Sign in to account</h4>
                <p>Enter your email & password to login</p>
                <div class="form-group">
                  <label class="col-form-label">Email Address</label>
                  <input
                      class="form-control"
                      type="email"
                      required=""
                      placeholder="Test@gmail.com"
                      v-model="email"
                  />
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <input
                      class="form-control"
                      type="password"
                      name="password"
                      v-model="password"
                      required=""
                      placeholder="*********"
                  />
                  <div class="show-hide"><span class="show"> </span></div>
                </div>
                <div class="form-group mb-0">
                  <div class="checkbox p-0">
                    <input id="checkbox1" type="checkbox"/>
                    <label class="text-muted" for="checkbox1"
                    >Remember password</label
                    >
                  </div>
                  <button class="btn btn-primary btn-block" type="submit">
                    Sign in
                  </button>
                </div>
                <p class="mt-4 mb-0">
                  Don't have account?
                  <router-link
                      class="ml-2"
                      tag="a"
                      to="/authentication/register"
                  >
                    Create Account
                  </router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    signUp() {
      this.submitted = true;
      const {dispatch} = this.$store;
      if (this.email && this.password) {
        dispatch("authentication/login", {
          'email': this.email,
          'password': this.password
        });
      }
    },
  },
};
</script>